import { useEffect } from 'react';
import { useLocation, useNavigate, useRoutes } from 'react-router-dom';
import { lazyLoadRoutes } from '../utils/lazy-loader';
import routes from '../constants/routes';

export function AppRoutes() {
  const appRoutes = [
    {
      path: '/',
      children: [
        {
          index: true,
          path: '/',
          element: <Root />
        },
        {
          path: routes.login,
          element: lazyLoadRoutes('auth/login')
        },
        {
          path: routes.register,
          element: lazyLoadRoutes('auth/register')
        },
        {
          path: routes.authGateWay,
          element: lazyLoadRoutes('auth/AuthGateWay')
        },
        {
          path: routes.registerOtpVerify,
          element: lazyLoadRoutes('auth/register-otp-verify')
        },
        {
          path: routes.resetPassword,
          element: lazyLoadRoutes('auth/reset-password')
        },
        {
          path: routes.forgotPassword,
          element: lazyLoadRoutes('auth/forgot-password')
        },
        {
          path: routes.profile,
          element: lazyLoadRoutes('profile', true)
        },
        {
          path: routes.parseResume,
          element: lazyLoadRoutes('resumeParsing/ResumeParsingProccess', true)
        },
        {
          path: routes.dashboard,
          element: lazyLoadRoutes('dashboard', true)
        },
        {
          path: routes.jobs,
          element: lazyLoadRoutes('jobs')
        },
        {
          path: `${routes.jobs}/:keyword`,
          element: lazyLoadRoutes('jobs')
        },
        {
          path: routes.searchJob,
          element: lazyLoadRoutes('jobs/search', true)
        },
        {
          path: routes.appliedJob,
          element: lazyLoadRoutes('jobs/applied', true)
        },
        {
          path: routes.savedJob,
          element: lazyLoadRoutes('jobs/saved', true)
        },
        {
          path: `${routes.jobDetails}/:slug`,
          element: lazyLoadRoutes('jobs/details', true)
        },
        {
          path: routes.views,
          element: lazyLoadRoutes('jobs/viewed', true)
        },
        {
          path: routes.jobAlert,
          element: lazyLoadRoutes('jobAlert/job-alert', true)
        },
        {
          path: routes.jobAlertAdd,
          element: lazyLoadRoutes('jobAlert/add-job-alert', true)
        },
        {
          path: `${routes.jobAlertAdd}/:id`,
          element: lazyLoadRoutes('jobAlert/add-job-alert', true)
        },
        {
          path: routes.settings,
          element: lazyLoadRoutes('settings/index', true)
        },
        {
          path: routes.changePassword,
          element: lazyLoadRoutes('settings/change-password', true)
        },
        {
          path: routes.subscription,
          element: lazyLoadRoutes('settings/subscription', true)
        },
        {
          path: routes.viewMessages,
          element: lazyLoadRoutes('messages/viewMessagesNew', true)
        },
        {
          path: routes.contact,
          element: lazyLoadRoutes('contact', true)
        },
        {
          path: routes.thankYou,
          element: lazyLoadRoutes('thank-you', true)
        },
        {
          path: routes.resumeParser,
          element: lazyLoadRoutes('resume-parser/index', true)
        },
        // {
        //   path: `${routes.accountVerify}/:encemail/:encuid`,
        //   element: lazyLoadRoutes('confirmation/account-verify')
        // },
        // {
        //   path: `${routes.interviewResponse}/:itoken/:etoken/:action`,
        //   element: lazyLoadRoutes('confirmation/interview-response')
        // },
        // {
        //   path: `${routes.verifyEmailChange}/:encemail/:encuid`,
        //   element: lazyLoadRoutes('confirmation/verify-email-change')
        // },
        // {
        //   path: routes.deleteProfile,
        //   element: lazyLoadRoutes('settings/delete-profile', true)
        // },

        {
          path: routes.notFound,
          element: lazyLoadRoutes('not-found')
        }
      ]
    },
    {
      path: '*',
      element: lazyLoadRoutes('not-found')
    }
  ];

  return useRoutes(appRoutes);
}

function Root() {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (location.pathname === '/') navigate(routes.login);
  }, [location]);

  return <></>;
}
